var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Delete Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,6H28.7l-0.9-2.6c-0.7-2-2.6-3.4-4.7-3.4h-6.2c-2.2,0-4.1,1.4-4.7,3.4L11.3,6H0v2h3l1.6,31.5  c0.2,4.8,4.2,8.5,9,8.5h12.8c4.8,0,8.7-3.8,9-8.5L37,8h3V6z M14,4.1C14.4,2.8,15.6,2,16.9,2h6.2c1.3,0,2.4,0.8,2.8,2.1L26.6,6H13.4  L14,4.1z M33.4,39.4c-0.2,3.7-3.3,6.6-7,6.6H13.6c-3.7,0-6.8-2.9-7-6.6L5,8h29.9L33.4,39.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    transform: "matrix(.999 -.045626 .045626 .999 -1.1701 .7343)",
    x: 14.5,
    y: 15,
    width: 2,
    height: 21.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    transform: "matrix(.045379 -.999 .999 .045379 -1.6304 50.294)",
    x: 14.5,
    y: 25,
    width: 21.9,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.0cd06b85ed37928ec2f3c46ee8fc388b.svg";
export { ForwardRef as ReactComponent };